import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid } from '@material-ui/core'
import { Close as BaseCloseIcon } from '@material-ui/icons'

export const Root = styled.div`
  box-sizing: border-box;
  padding: 0 0 130px;
  width: 100%;
`

export const DesktopNavigation = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 0 0 0 30px;

  ${props => props.theme.breakpoints.down('md')} {
    justify-content: center;
    margin: 0;
  }
`

export const MobileNavigation = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 32px;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};
`

export const Title = styled.h1`
  color: ${props => props.theme.palette.custom.mineShaft};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  letter-spacing: 0;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const Instructions = styled.p`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 1.3;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const Subtitle = styled.h2`
  color: ${props => props.theme.palette.custom.dimGray};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const SelectedAreas = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(auto, 300px));
  gap: 10px;
  ${props => props.theme.breakpoints.only('xs')} {
    width: 100%;
  }
`

export const SelectedArea = styled.section`
  align-items: center;
  background-color: ${props => props.theme.palette.gray[95]};
  border-radius: 5px;
  display: inline-grid;
  grid-template-columns: auto 50px;
  flex: none;
  margin: 0 5px 5px 0;
  padding: 15px 14px;
  width: auto;
`

export const SelectedAreaText = styled.span`
  color: ${props => props.theme.palette.custom.dimGray};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  opacity: 0.61;
`

export const SelectedAreaRemove = styled.span`
  align-items: center;
  display: inline-flex;
  justify-content: flex-end;
  text-align: right;
`

export const SelectedAreaRemoveIcon = styled(BaseCloseIcon)`
  color: ${props => props.theme.palette.brand.black3};
  cursor: pointer;
  font-size: 12px;
`
